import React from 'react';
import { useT } from '../../i18n/LocaleContext';
import ProgressBar from '../ui/ProgressBar';
import EmptyState from '../ui/EmptyState';

const MONTH_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export default function UpcomingEvents({ events }) {
  const t = useT();
  if (!events || events.length === 0) {
    return <EmptyState title={t('events.empty_title')} body={t('events.empty_body')} />;
  }
  return (
    <div>
      {events.map((event) => {
        const date = new Date(event.date);
        const day = date.getDate();
        const monthAbbr = t(`months.abbr.${MONTH_KEYS[date.getMonth()]}`);
        // Capacity 0 = no limit: show how many are booked instead of places left.
        const unlimited = !(event.capacity > 0);
        const remaining = unlimited ? event.registered : Math.max(0, event.capacity - event.registered);
        const progress = event.capacity ? (event.registered / event.capacity) * 100 : 0;

        return (
          <div key={event.id} style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 0', borderBottom: '1px solid rgba(226,221,212,0.5)' }}>
            <div style={{
              width: '46px', height: '46px',
              background: 'var(--gold-pale)',
              border: '1px solid rgba(201,168,76,0.35)',
              borderRadius: '8px',
              display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: '18px', color: 'var(--blue-deep)', lineHeight: 1 }}>{day}</div>
              <div style={{ fontSize: '9px', color: 'var(--gold)', textTransform: 'uppercase', letterSpacing: '1px', fontFamily: "'Cinzel', serif" }}>{monthAbbr}</div>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '13.5px', fontWeight: '500', color: 'var(--text)' }}>{event.name}</div>
              <div style={{ fontSize: '11.5px', color: 'var(--text-muted)', marginTop: '1px', fontStyle: 'italic' }}>{event.destination}</div>
              <div style={{ marginTop: '5px' }}>
                <ProgressBar value={progress} />
              </div>
            </div>
            <div style={{ marginLeft: 'auto', textAlign: 'right', fontSize: '11.5px', color: 'var(--text-muted)' }}>
              <strong style={{ fontFamily: "'Cinzel', serif", fontSize: '16px', color: 'var(--blue-mid)', display: 'block' }}>{remaining}</strong>
              {unlimited ? t('dashboard.booked') : t('dashboard.spots_left')}
            </div>
          </div>
        );
      })}
    </div>
  );
}
